export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/triangulate.worker.a4ddcd3b.worker.js");
}
